import React from 'react';
import { SlideOver } from './items/SlideOver';
import { TbFileCertificate } from 'react-icons/tb';

const LicenseForm = ({ isActive, onClose }) => {
  //todo
  return (
    <SlideOver
      title={
        <span className={'flex items-center gap-1'}>
          Add New License
          <TbFileCertificate size={20} />
        </span>
      }
      open={isActive}
      onClose={() => onClose()}>
      License Form
    </SlideOver>
  );
};

export default LicenseForm;
